/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module TrafficLogsModule
 */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { TTrafficLog } from '../traffic-logs.types';
import { TrafficLogListExpandedContentStore } from './traffic-log-list-expanded-content.store';

/**
 * @description
 *     Component used for showing summary info in traffic log list expanded contents.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'traffic-log-list-expanded-content',
    templateUrl: 'traffic-log-list-expanded-content.component.html',
    providers: [TrafficLogListExpandedContentStore],
})
export class TrafficLogListExpandedContentComponent implements OnInit {
    /**
     * The log entry to be displayed with summary information in the expanded content.
     */
    @Input()
    public log: TTrafficLog;

    /**
     * Handler for opening a c-view to inspect the full log.
     */
    @Output()
    public readonly viewFullLog: EventEmitter<TTrafficLog> = new EventEmitter<TTrafficLog>();

    public readonly isSignificantLog$ = this.componentStore.isSignificantLog$;

    public readonly significantLog$ = this.componentStore.significantLog$;

    constructor(public readonly componentStore: TrafficLogListExpandedContentStore) {}

    /**
     * @override
     */
    public ngOnInit(): void {
        this.componentStore.setLogBasedOnType(this.log);
    }

    public handleViewFullLog(): void {
        this.viewFullLog.emit(this.log);
    }
}
